export default "__VITE_PUBLIC_ASSET__a860abfe__"